import Configure from 'lib/pages/Configure'
export default Configure
